import { type BulkModifyAccountsInput, type BulkModifyAccountsSuccess, Logger } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'

const logger = new Logger('useAccountBulkModify')

export function useAccountBulkModify(): UpdateHookResponse<BulkModifyAccountsInput, void> {
  logger.verbose('calling useAccountBulkModify')
  const mutation = useTantalimMutation<BulkModifyAccountsInput, BulkModifyAccountsSuccess>({ url: '/account/bulk' })

  async function update(input: BulkModifyAccountsInput): Promise<void> {
    await mutation.mutateAsync(input)
    logger.verbose('bulk modify accounts request sent')
  }

  return mutationUpdate(mutation, update)
}
